(function () {
  "use strict";

  function isHeading(node) {
    return node && node.nodeType === 1 && /^(H2|H3|H4)$/.test(node.tagName);
  }

  function isBoundary(node) {
    if (!node || node.nodeType !== 1) return false;
    return node.matches(".km-product-trust-copy, .km-specs-data") ||
      (!isHeading(node) && node.querySelector("h2, h3, h4"));
  }

  function wrapHeadings(container, state) {
    var headings = Array.prototype.filter.call(container.children, isHeading);

    headings.forEach(function (heading) {
      if (heading.closest(".km-desc-chapter")) return;

      var chapter = document.createElement("section");
      var head = document.createElement("div");
      var index = document.createElement("span");
      var body = document.createElement("div");
      var cursor = heading.nextSibling;

      chapter.className = "km-desc-chapter";
      head.className = "km-desc-chapter-head";
      index.className = "km-desc-index";
      body.className = "km-desc-chapter-body";
      index.textContent = String(state.index++).padStart(2, "0");

      container.insertBefore(chapter, heading);
      head.appendChild(index);
      head.appendChild(heading);
      chapter.appendChild(head);
      chapter.appendChild(body);

      while (cursor) {
        var next = cursor.nextSibling;
        if (isHeading(cursor) || isBoundary(cursor)) break;
        body.appendChild(cursor);
        cursor = next;
      }

      if (!body.textContent.trim() && !body.querySelector("img, table, video, iframe")) {
        body.remove();
        chapter.classList.add("km-desc-chapter--heading-only");
      }
    });
  }

  function enhanceDescription(root) {
    if (!root || root.dataset.kmEditorialReady === "true") return;
    root.dataset.kmEditorialReady = "true";
    root.classList.add("km-desc-editorial");

    var header = document.createElement("div");
    header.className = "km-desc-header";
    header.innerHTML =
      '<div><span class="km-desc-eyebrow">Análisis del modelo</span>' +
      "<h2>Detalles que importan</h2></div>" +
      '<span class="km-desc-header-mark" aria-hidden="true">K</span>';
    root.insertBefore(header, root.firstChild);

    var state = { index: 1 };
    var nested = Array.prototype.filter.call(root.children, function (child) {
      return !child.classList.contains("km-desc-header") &&
        Array.prototype.some.call(child.children || [], isHeading);
    });

    nested.forEach(function (container) {
      container.classList.add("km-desc-source");
      var firstParagraph = Array.prototype.find.call(container.children, function (child) {
        return child.tagName === "P";
      });
      if (firstParagraph && firstParagraph.previousElementSibling === null) {
        firstParagraph.classList.add("km-desc-lead-inner");
      }
      wrapHeadings(container, state);
    });

    wrapHeadings(root, state);

    var directParagraph = Array.prototype.find.call(root.children, function (child) {
      return child.tagName === "P";
    });
    if (directParagraph) directParagraph.classList.add("km-desc-lead");
  }

  function init() {
    enhanceDescription(document.querySelector("#description .product-description-wrapper"));
    document.querySelectorAll("#review .km-pr-stars").forEach(function (stars) {
      stars.textContent = String.fromCharCode(9733).repeat(5);
      stars.setAttribute("aria-label", "5 estrellas");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
